module.exports = __webpack_public_path__ + "img/4_56.717a6901.png";